import React, { useState, useEffect } from 'react';
import { ListSubheader, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import MenuItem from '@material-ui/core/MenuItem';
import { FormProvider } from 'react-hook-form';
import localStorageUtil from '@/common/utils/localStorageUtil';
import FormInput from '@/component/common/form/input';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import LoadingPanel from '@/component/common/LoadingPanel';
import ErrorMessageHeader from '../common/ErrorMessageHeader';
import '../common/ErrorMessageHeader.css';
import ButtonSubmitAddTicket from './ButtonSubmitAddTicket';
import { DialogConfirmCancelEditTicket } from '@/component/chatThread/editTicketDialog/DialogConfirmCancelEditTicket';
import './QaTicket.css';
import {
    getHelpDeskListOfProject,
    handleOnchangeProject,
    onSubmitCreateQaTicket,
    getListFormQAOfProject,
    handleOnchangeForm,
    getProjectLabel,
    handleCloseSelectProject,
    handleOpenSelectProject,
    handleCloseSelectForm,
    handleOpenSelectForm,
    onSubmitSaveDraftQaTicket,
    checkIsDisableButtonDraft,
    checkIsDisableBtnSent,
    getProjectInternalLabel,
    initDataPanelCreateTicket,
    submitOnchangeProject,
    renderDraftTicketDetail,
    onSubmitDeleteDraftQaTicket
} from './handler/QaTicketHandler';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    closePanelTabSelector,
    triggerReloadTicketListByPanelType,
    updatePanelAfterCreateTicketSelector
} from '@/state/selector/panelSelector';

import {
    multiPanelAtom,
    panelStartIndexAtom,
    panelSettingAtom,
    closeTabId,
    panelInitDataAtom,
    lastActivePanelIdAtom
} from '@/state/atom/panelAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import Utils from '@/common/utils/utils';
import CustomSchema from '@/schema/CustomSchema';
import {
    permissionCreateTicketExternalDeskRequest,
    permissionCreateTicketInviteGuestDesk
} from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import RenderFieldUI from '../formManagement/RenderFieldUI';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { I18n } from 'aws-amplify';
import {
    getOptionSearchLabel,
    isShowExternalDeskRequestSystemForm,
    onChangeExternalDeskInput,
    onKeyPressSearchExternalDeskProject,
    searchExternalDeskProject,
    selectExternalDeskProject,
    handleOnBlurExternalDeskRequest
} from './handler/ExternalQaTicketHandler';
import { useSnackbar } from 'notistack';
import { Autocomplete } from '@material-ui/lab';
import { DialogConfirmChangeDeskOrForm } from './addTicketDialog/DialogConfirmChangeDeskOrForm';
import { DialogConfirmChangeTicketTypeDraftFlow } from './addTicketDialog/DialogConfirmChangeTicketTypeDraftFlow';
import { DialogConfirmChangeForm } from './addTicketDialog/DialogConfirmChangeForm';

import { formListOfProjectSelector } from '@/state/selector/formSelector' ;
import { DialogConfirmCancelCreateTicket } from './addTicketDialog/DialogConfirmCancelCreateTicket';
import { getProjectById, getProjectDeskOnPublicOn } from '@/service/projectService';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { getPanelInitData, updatePanelInitData, removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import _, { cloneDeep } from 'lodash';
import ConfirmDialog from '../../common/dialog/ConfirmDialog';
import { DialogConfirmChangeTicketError } from './addTicketDialog/DialogConfirmChangeTicketError';
import {showLoadingMouse, hideLoadingMouse} from '../../common/utils/CustomCursor'
import FieldInvitedPartnerB2b from './customerSide/FieldInvitedPartnerB2b';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import { isDataInputUrlError } from './handler/KnowledgeTicketHandler';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import {
    setPanelSelector
} from '@/state/selector/panelSelector';
import { getFormFromFormListById, unregisterField } from './handler/TicketHandler';
import PropTypes from 'prop-types';

export default function QATicket(props) {
    const DIALOG_CONFIRM_TYPE = {
        DEFAULT: '',
        FORCE_CREATE_INVITE_GUEST_DESK: 'FORCE_CREATE_INVITE_GUEST_DESK'
    }

    // Get common state for close panel when add ticket done
    const panelChildren = window.innerWidth > 991 ? 3 : 1;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);
    const [settingSlide, setSettingSlide] = useRecoilState(panelSettingAtom);
    const corporationId = localStorageUtil.getAffiliationOrganization();
    const currentProjectId = localStorageUtil.getSelectedProjectId();
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);
    const [displayMode, setDisplayMode] = useState(Constant.DISPLAY_MODE.VIEW);

    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);

    // common corporationDetail state
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);

    // common projectInuse state
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);

    // common form
    const [currentCorporationFormList, setCurrentCorporationFormList] = useRecoilState(
        formListOfProjectSelector
    );

    // check is admin
    const isAdmin = Utils.isAdminUser(userDetail);

    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [corporationTarget, setCorporationTarget] = useState('');
    const [projectTarget, setProjectTarget] = useState('');

    const [fileUploadList, setFileUploadList] = useState([]);
    const [fieldListData, setFiledListData] = useState([]);
    const [formList, setFormList] = useState([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [requestType, setRequestType] = useState('');
    const [selectedFormInfo, setSelectedFormInfo] = useState({});
    const [createTicketType, setCreateTicketType] = useState(Constant.TICKET_TYPE.QA);

    const [internalHelpDeskList, setInternalHelpDeskList] = useState([]);
    const [externalHelpDeskList, setExternalHelpDeskList] = useState([]);

    // External desk request content
    // Create external desk request
    const [externalDeskRequestProject, setExternalDeskRequestProject] = useState({});
    const [externalDeskRequestKeyword, setExternalDeskRequestKeyword] = useState('');
    const [externalDeskProjectList, setExternalDeskProjectList] = useState([]);

    // Open/Close external desk list prj
    const [openExternalDeskList, setOpenExternalDeskList] = useState(true);
    
    // Define error when search external desk project
    const [externalDeskProjectErr, setExternalDeskProjectErr] = useState({
        error: false,
        helperText: ''
    });
    const [errorMessageHeader, setErrorMessageHeader] = useState('');

    const validateCreateQaTicket = useForm({
        mode: 'all',
        shouldUnregister: true,
        defaultValues: {
            outline: '',
            category: '',
            description: '',
            field_qa_category: []
        },
        resolver: yupResolver(CustomSchema(fieldListData))
    });
    const handleSubmitCreateQaTicket = validateCreateQaTicket.handleSubmit;
    const errorCreateQaTicket = validateCreateQaTicket.errors;
    const clearErrors = validateCreateQaTicket.clearErrors;
    const setValueCreateQaTicket = validateCreateQaTicket.setValue;
    const registerCreateQaTicket = validateCreateQaTicket.register;
    const unregisterCreateQaTicket = validateCreateQaTicket.unregister;
    const getValuesCreateQaTicket = validateCreateQaTicket.getValues;
    const resetValuesCreateQaTicket = validateCreateQaTicket.reset;
    const setErorsQATicket = validateCreateQaTicket.setError;
    const triggerValidate = validateCreateQaTicket.trigger;

    const [isExChangeTagField, setIsExChangeTagField] = useState(false);

    const [isConfirmChangeDeskOrForm, setIsConfirmChangeDeskOrForm] = useState(false);
    const [dialogConfirmType, setDialogConfirmType] = useState('');
    const [selectedProjectChange, setSelectedProjectChange] = useState('');
    const [isOpenSelectProject, setIsOpenSelectProject] = useState(false);
    const [selectedFormChange, setSelectedFormChange] = useState('');
    const [isOpenSelectForm, setIsOpenSelectForm] = useState(false);
    const [isDisableButtonDraft, setIsDisableButtonDraft] = useState(true);
    const [isDisableButtonSent, setIsDisableButtonSent] = useState(true);

    const [autoFillObject, setAutoFillObject] = useState({});
    const [isConfirmCancelCreateTicket, setIsConfirmCancelCreateTicket] = useState(false);
    const [isCloseTabAction, setIsCloseTabAction] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(
        closeTabId
    );
    const [isEdited, setIsEdited] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isOpenDialogQAConfirmChangeTicketType, setIsOpenDialogQAConfirmChangeTicketType] = useState(false);
    const [isOpenDialogQAConfirmChangeFormType, setIsOpenDialogQAConfirmChangeFormType] = useState(false);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [onChangeEdit,setOnChangeEdit] = useState(false);

    const destinationProject = localStorageUtil.getDestinationProjectQueryParam();
    const isDraftMode = props.detailTicket && !Utils.isEmptyObject(props.detailTicket) ? true : false;
    const [triggerSaveFormData, setTriggerSaveFormData] = useState('');

    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
    const [confirmDialogObj, setConfirmDialogObj] = useState({open: false, msg: '', confirmType: ''});
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [isOpenPopupError, setIsOpenPopupError] = useState(false);
    const defaultMaxGeneralId = parseInt(props?.detailTicket?.invitationInfo?.maxGeneralId) || 1;
    const defaultSubdomainInvited = props?.detailTicket?.invitationInfo?.subDomainInvited || '';
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const addNewPanel = useSetRecoilState(setPanelSelector);

    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });
   const [isConfirmCancelEditTicket, setIsConfirmCancelEditTicket] = useState(false)

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            props?.API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            userDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API: props?.API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: userDetail,
                setUserDetail: setUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }

    const argsAll = {
        ...props,
        API: props?.API,
        corporationId,
        userDetail,
        corporationDetail,
        setCorporationDetail,
        projectInuseDetail,
        isAdmin,
        currentCorporationFormList,
        setCurrentCorporationFormList,

        panelChildren,
        panelList,
        currentIndex,
        settingSlide,
        closePanelTab,
        isCloseTabAction, 
        setIsCloseTabAction,

        setPanelListRecoilState: setPanelList,
        setCurrentIndex,
        setSettingSlide,
        isLoading,
        setIsLoading,
        setFileUploading: props.setFileUploading,
        setIsModalUploadFileError: props.setIsModalUploadFileError,
        enqueueSnackbar,
        hideLoadingMouse,

        fieldListData,
        setFiledListData,
        formList,
        setFormList,
        selectedForm,
        setSelectedForm,
        requestType,
        setRequestType,
        selectedFormInfo,
        setSelectedFormInfo,
        createTicketType,
        setCreateTicketType,

        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),

        projectTarget,
        setProjectTarget,
        corporationTarget,
        setCorporationTarget,
        internalHelpDeskList,
        externalHelpDeskList,

        getValuesCreateQaTicket,
        setValueCreateQaTicket,
        unregisterCreateQaTicket,
        resetValuesCreateQaTicket,

        setInternalHelpDeskList,
        setExternalHelpDeskList,
        fileUpdatedList,
        setFileUpdatedList,
        displayMode,
        setDisplayMode,

        // External desk request
        externalDeskProjectList,
        setExternalDeskProjectList,
        externalDeskRequestProject,
        setExternalDeskRequestProject,
        externalDeskRequestKeyword,
        setExternalDeskRequestKeyword,
        openExternalDeskList,
        setOpenExternalDeskList,
        externalDeskProjectErr,
        setExternalDeskProjectErr,

        errorMessageHeader,
        setErrorMessageHeader,

        // Dialog confirm
        dialogConfirmType,
        setDialogConfirmType,
        isConfirmChangeDeskOrForm,
        setIsConfirmChangeDeskOrForm,

        selectedProjectChange,
        setSelectedProjectChange,
        isOpenSelectProject,
        setIsOpenSelectProject,

        selectedFormChange,
        setSelectedFormChange,
        isOpenSelectForm,
        setIsOpenSelectForm,
        isDisableButtonDraft,
        setIsDisableButtonDraft,
        isDisableButtonSent,
        setIsDisableButtonSent,
        isConfirmCancelCreateTicket,
        setIsConfirmCancelCreateTicket,

        fileUploadList,
        setFileUploadList,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        panelInitData,
        setPanelInitData,
        currentPanelInitData,
        setCurrentPanelInitData,
        isOpenDialogQAConfirmChangeTicketType,
        setIsOpenDialogQAConfirmChangeTicketType,
        isOpenDialogQAConfirmChangeFormType, 
        setIsOpenDialogQAConfirmChangeFormType,
        isEdited,
        setIsEdited,
        isDraftMode,
        triggerSaveFormData,
        setTriggerSaveFormData,
        isOpenDeleteDialog,
        setIsOpenDeleteDialog,
        confirmDialogObj, 
        setConfirmDialogObj,
        reloadTicketListByPanelType,
        isOpenPopupError,
        setIsOpenPopupError,
        DIALOG_CONFIRM_TYPE,
        errorCreateQaTicket,
        setErorsQATicket,
        lastUserAction,
        setLastUserAction,
        setUserDetail,
        updatePanelInitData,
        clearErrors,
        removePanelInitData
    };

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
    }, [isEdited])

    useEffect(() => {
        // Update panelInitDataAtom
        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'argsAll', newArgsAll);

    }, [projectTarget, selectedForm, externalDeskRequestProject, internalHelpDeskList, externalHelpDeskList, fileUploadList, fileUpdatedList]);

    useEffect(() => {
        clearErrors();
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'displayMode',
            displayMode
        );
    }, [displayMode]);

    const filterProjectDeskOn = (projectList) => {
        if(Utils.isEmptyArray(projectList))
            return [];
        
        return projectList?.filter(project => {
            return (Utils.isPublicDesk(project) || Utils.isPrivateDesk(project))
        })
    }

    useEffect(() => {
        if (isLoading) {
            return showLoadingMouse();
        } 
        return hideLoadingMouse();
    
     }, [isLoading]);

    useEffect(() => {
        registerCreateQaTicket('corporationTarget');
        registerCreateQaTicket('projectTarget');
        registerCreateQaTicket('fileUploadList');
        registerCreateQaTicket('attachments');
        registerCreateQaTicket('selectedForm');
        registerCreateQaTicket('maxGeneralId');

        if (props?.selectedTicketType === Constant.QA_CREATE_TICKET_TYPE.INVITATION) {
            setRequestType(Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST);
            setProjectTarget(Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST);
        }

        let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
        if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes)) {

            if (
                currentPanelInitDataRes?.displayMode === Constant.DISPLAY_MODE.VIEW &&
                !currentPanelInitDataRes?.isEditedData &&
                isDraftMode
            ) {
                renderDraftTicketDetail(argsAll)
                    .then()
                    .catch();
            }

            setCurrentPanelInitData(currentPanelInitDataRes);
            if (currentPanelInitDataRes.argsAll) {
                initDataPanelCreateTicket(currentPanelInitDataRes, argsAll);
                return;
            }
        }
        
        // if(!isDraftMode){
            setIsLoading(true);
        // }
        if (userDetail.type === Constant.USER_TYPE.CUSTOMER && projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
            getProjectDeskOnPublicOn(props?.API, corporationDetail.id, userDetail.id)
                .then(async projectList => {
                    let projectRejectedList = userDetail.projectRejected && !Utils.isEmptyArray(userDetail.projectRejected) ? userDetail.projectRejected : [];
                    if (!Utils.isEmptyArray(projectRejectedList)) {
                        projectList = projectList.filter(projectResult => !projectRejectedList.includes(projectResult.id));
                    }
                    let listDeskProjectOfUser = filterProjectDeskOn(projectList);
                    listDeskProjectOfUser = _.orderBy(listDeskProjectOfUser, ['createdAt'], ['asc'])
                    setInternalHelpDeskList(listDeskProjectOfUser);

                    if(isDraftMode && Utils.isEmptyObject(currentPanelInitDataRes.argsAll)){
                        let cloneArgsAll = cloneDeep(argsAll);
                        cloneArgsAll.internalHelpDeskList = listDeskProjectOfUser;
                        await renderDraftTicketDetail(cloneArgsAll);
                        return;
                    }

                    const projectTargetDefaultId = listDeskProjectOfUser.findIndex(item => 
                        Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name) === destinationProject);
                    if (projectTargetDefaultId > -1) {
                        setProjectTarget(listDeskProjectOfUser[projectTargetDefaultId].id);
                        let helpdeskInviteFormQAList = await getListFormQAOfProject(
                            props?.API,
                            listDeskProjectOfUser[projectTargetDefaultId].affiliationOrganization,
                            listDeskProjectOfUser[projectTargetDefaultId].id
                        );
                        setValueCreateQaTicket('projectTarget', listDeskProjectOfUser[projectTargetDefaultId].id);
                        setFormList(helpdeskInviteFormQAList);
                        // let cloneArgsAll = cloneDeep(argsAll);
                        // cloneArgsAll.internalHelpDeskList = listDeskProjectOfUser;
                        await submitOnchangeProject(listDeskProjectOfUser[projectTargetDefaultId].id, argsAll);
                    }
                    let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                    let lastFormOfProject = workLastForm[projectInuseDetail.id];
                    if (
                        lastFormOfProject &&
                        !isDraftMode &&
                        Utils.isEmptyString(currentPanelInitDataRes?.argsAll?.selectedForm)
                    ) {
                        await initDataLastForm(lastFormOfProject);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    setInternalHelpDeskList([]);
                    setIsLoading(false);
                })
                .finally(() => {
                    // if(!isDraftMode){
                    //     setIsLoading(false);
                    // }
                    setIsLoading(false);
                });
        } else {
            getHelpDeskListOfProject(props?.API, corporationId, projectInuseDetail)
                .then(async helpDeskData => {
                    helpDeskData.internalHelpDeskList = filterProjectDeskOn(helpDeskData.internalHelpDeskList);
                    helpDeskData.externalHelpDeskList = helpDeskData.externalHelpDeskList?.filter(project => {
                        return (((Utils.isPublicDesk(project) || Utils.isProjectGuestDesk(project)))) && project?.corporationData?.deskService === Constant.STATUS_SERVICE_PERMISSION.ON
                    });
                    setInternalHelpDeskList(helpDeskData.internalHelpDeskList);
                    setExternalHelpDeskList(helpDeskData.externalHelpDeskList);

                    let projectTargetDefaultId;
                    projectTargetDefaultId = helpDeskData.internalHelpDeskList.findIndex(item => 
                        Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name) === destinationProject);
                    if (projectTargetDefaultId > -1) {
                        setProjectTarget(helpDeskData.internalHelpDeskList[projectTargetDefaultId].id);
                        await submitOnchangeProject(helpDeskData.internalHelpDeskList[projectTargetDefaultId].id, argsAll);
                    }

                    if(argsAll.isDraft){
                        argsAll.draftInternalHelpDeskList = helpDeskData.internalHelpDeskList;
                        argsAll.draftExternalHelpDeskList = helpDeskData.externalHelpDeskList;
                    }
                    
                    // Set default if prj inuse is guest
                    if (
                        Utils.isProjectGuest(projectInuseDetail) &&
                        !Utils.isEmptyArray(helpDeskData.externalHelpDeskList)
                    ) {
                        let helpdeskInvite = helpDeskData.externalHelpDeskList[0];
                        let helpdeskInviteFormQAList = await getListFormQAOfProject(
                            props?.API,
                            helpdeskInvite.affiliationOrganization,
                            helpdeskInvite.id
                        );

                        setProjectTarget(helpdeskInvite.id);
                        setCorporationTarget(helpdeskInvite.affiliationOrganization);
                        setValueCreateQaTicket('projectTarget', helpdeskInvite.id);
                        setValueCreateQaTicket(
                            'corporationTarget',
                            helpdeskInvite.affiliationOrganization
                        );
                        setFormList(helpdeskInviteFormQAList);
                    }
                    if(isDraftMode && Utils.isEmptyObject(currentPanelInitDataRes.argsAll)){
                        await renderDraftTicketDetail(argsAll);
                    }
                    // if(!isDraftMode){
                    //     setIsLoading(false);
                    // }

                    let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                    let lastFormOfProject = workLastForm[projectInuseDetail.id];
                    if (
                        lastFormOfProject &&
                        !isDraftMode &&
                        !argsAll.isDraft &&
                        Utils.isEmptyString(currentPanelInitDataRes?.argsAll?.selectedForm)
                    ) {
                        await initDataLastForm(lastFormOfProject);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    setInternalHelpDeskList([]);
                    setExternalHelpDeskList([]);
                    setProjectTarget('');
                    setCorporationTarget('');
                    // if(!isDraftMode){
                    //     setIsLoading(false);
                    // }
                    setIsLoading(false);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }

        // setTriggerSaveFormData(Date.now().toString());
    }, []);

    const initDataLastForm = async (lastFormOfProject) => {
        setIsLoading(true);
        if (props?.selectedTicketType === Constant.QA_CREATE_TICKET_TYPE.INVITATION) {
            let lastFormInviteOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_INVITED_QA];
            if (!Utils.isEmptyObject(lastFormInviteOfProject)) {
                // Validate form
                let selectedFormDetail = await getFormFromFormListById(lastFormInviteOfProject?.formId);
                if (Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(projectInuseDetail.id)) {
                    setIsLoading(false);
                    return;
                }
                setRequestType(Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST);
                unregisterField(fieldListData, unregisterCreateQaTicket);
                setFormList([]);
                setProjectTarget(Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST);
                setCorporationTarget('');
                setValueCreateQaTicket('');

                if (selectedFormDetail.type === Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK && permissionCreateTicketInviteGuestDesk(
                    userDetail,
                    projectInuseDetail.type,
                    formInviteGuestDeskInfo.status,
                    corporationDetail.limitValue?.numOfGuestDesk,
                    corporationDetail.contractType
                )) {
                    setIsLoading(false);
                    return;
                }
                setFiledListData([]);
                setSelectedForm(lastFormInviteOfProject?.formId);
                setSelectedFormInfo(selectedFormDetail);
                let e = {
                    target: {
                        dataset: {
                            value: lastFormInviteOfProject?.formId
                        }
                    }
                }
                await handleOnchangeForm(e, argsAll);
            }
            return;
        }

        // Render width last QA form
        let lastFormQAOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_QA];
        if (!Utils.isEmptyObject(lastFormQAOfProject)) {
            // Validate Project
            let projectTargetDetail = await getProjectById(props?.API, lastFormQAOfProject?.projectTargetId);
            if (Utils.isEmptyObject(projectTargetDetail) || projectTargetDetail?.active === Constant.ACTIVE_FLAG.ACTIVE_FLAG || !projectTargetDetail?.isDesk) {
                setIsLoading(false);
                return;
            }
            setCreateTicketType(Constant.TICKET_TYPE.QA);
            setRequestType('');

            setProjectTarget(lastFormQAOfProject.projectTargetId);
            setCorporationTarget(lastFormQAOfProject.corpTargetId);
            setValueCreateQaTicket('projectTarget', lastFormQAOfProject.projectTargetId);
            setValueCreateQaTicket('corporationTarget', lastFormQAOfProject.corpTargetId);

            let listFormQAOfSelectedProject = await getListFormQAOfProject(props?.API, lastFormQAOfProject?.corpTargetId, lastFormQAOfProject?.projectTargetId);
            setFormList(listFormQAOfSelectedProject);

            // Validate Form
            let selectedFormDetail = await getFormFromFormListById(lastFormQAOfProject.formId);
            if (Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(lastFormQAOfProject?.projectTargetId)) {
                setIsLoading(false);
                return;
            }

            setValueCreateQaTicket('selectedForm', '');
            setValueCreateQaTicket('fileUploadList', []);
            setFiledListData([]);
            setSelectedForm(lastFormQAOfProject.formId);
            setSelectedFormInfo(selectedFormDetail);
            let e = {
                target: {
                    dataset: {
                        value: lastFormQAOfProject.formId
                    }
                }
            }
            await handleOnchangeForm(e, argsAll);
        }
    }

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isEdited) {
                setIsCloseTabAction(true);
                setIsConfirmCancelCreateTicket(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
                removePanelInitData(props.panelId,  props.tabId, panelInitData, setPanelInitData);
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);


    useEffect(() => {
        if ((lastActivePanelId && lastActivePanelId.panelId === props.panelId && lastActivePanelId.tabId === props.tabId) || triggerSaveFormData) {
            let formData = getValuesCreateQaTicket();
            if (!Utils.isEmptyArray(fieldListData)) {
                let fieldAttachments = fieldListData.find(field => field.sysField === 'attachments');
                if (!Utils.isEmptyObject(fieldAttachments)) {
                    let defaultFileUpload = [];
                    if (!Utils.isEmptyArray(fileUpdatedList)) {
                        defaultFileUpload = fileUpdatedList.filter(file => !file.isDelete);
                    } else if (!Utils.isEmptyArray(fieldAttachments.defaultValue)) {
                        defaultFileUpload = fieldAttachments.defaultValue;
                    } else if (!Utils.isEmptyArray(fieldAttachments.value)) {
                        defaultFileUpload = fieldAttachments.value;
                    }
                    formData[fieldAttachments.id] = defaultFileUpload;
                    formData['fileUploadList'] = defaultFileUpload;
                }
            }
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'formData', formData);
        }
    }, [lastActivePanelId, triggerSaveFormData]);

    const formExternalDeskRequestInfo = isShowExternalDeskRequestSystemForm(
        Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK,
        currentCorporationFormList,
        projectInuseDetail
    );

    const formInviteGuestDeskInfo = isShowExternalDeskRequestSystemForm(
        Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK,
        currentCorporationFormList,
        projectInuseDetail
    );

    const handleCreateQaTicket = (formData, forceCreate = false) => {
        return onSubmitCreateQaTicket(
            argsAll,
            formData,
            props.panelId,
            props.panelType,
            props.tabId,
            forceCreate
        );
    };

    const handleSubmitSaveDraft = () => {
        let formData = getValuesCreateQaTicket();
        let isExistUrlError = isDataInputUrlError(fieldListData, errorCreateQaTicket);
        if (isExistUrlError) {
            return;
        }
        
        // cleanup state
        setFileUploadList([]);

        return onSubmitSaveDraftQaTicket(
            argsAll,
            formData,
            props.panelId,
            props.panelType,
            props.tabId
        );
    };

    useEffect(() => {
        setIsDisableButtonDraft(checkIsDisableButtonDraft(argsAll));
        setIsDisableButtonSent(checkIsDisableBtnSent(argsAll));
    });

    const handleSubmitDeleteDraft = () => {
        return onSubmitDeleteDraftQaTicket(
            argsAll,
            props.panelId,
            props.panelType,
            props.tabId
        );
    }

    const onClickCloseConfirmDialog = () => {
        setConfirmDialogObj({open: false, msg: ''})
    }

    const onClickOkConfirmDialog = () => {
        switch (confirmDialogObj?.confirmType) {
            case DIALOG_CONFIRM_TYPE.FORCE_CREATE_INVITE_GUEST_DESK:
                let formData = getValuesCreateQaTicket();
                handleCreateQaTicket(formData, true);
                break;
            default:
                handleSubmitDeleteDraft();
                break;
        }

        setConfirmDialogObj({open: false, msg: ''});
    }

    const onClickDelete = () => {
        setConfirmDialogObj({open: true, msg: I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST')})
    }

    const permissionShowFormCreateTicket = () => {
        if (Utils.isEmptyArray(fieldListData)) return false;
        if (createTicketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) return true;
        if (
            !permissionCreateTicketInviteGuestDesk(
                userDetail,
                projectInuseDetail.type,
                formInviteGuestDeskInfo.status,
                corporationDetail.limitValue?.numOfGuestDesk,
                corporationDetail.contractType,
                corporationDetail.limitValue?.maxNumOfGuestDesk
            )
        )
            return false;
        return true;
    };

    const isCreateInviteTicket = () => {
        let isInviteTicket = false;
        let ticketDetail = argsAll?.detailTicket;
        if([Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT, Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK].includes(ticketDetail?.ticketType)){
            isInviteTicket = true;
        }

        return props?.selectedTicketType === Constant.QA_CREATE_TICKET_TYPE.INVITATION || isInviteTicket;
    }

    const isEnableFields = () => {
        if (isDraftMode) return displayMode === Constant.DISPLAY_MODE.EDIT;

        return true;
    };

    const handleResetFormData = () => {
        if (props?.setTriggerReLoadHelpdeskTicketDetail)
            props?.setTriggerReLoadHelpdeskTicketDetail(props?.detailTicket?.id);
            
        // Clear all err
        clearErrors();
        setIsEdited(false);
        setErrorMessageHeader('');
        setListFieldEdited([]);
        setFileUploadList([]);
        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        removePanelInitData(props.panelId,  props.tabId, panelInitData, setPanelInitData);
    };

    const generateDefaultValueByFieldId = fieldId => {
        let defaultValueOfField = null;
        defaultValueOfField = currentPanelInitData?.formData?.[fieldId] ?? null;
                
        if (
            defaultValueOfField == null &&
            !Utils.isEmpty(currentPanelInitData?.argsAll?.currentPanelInitData?.formData?.[fieldId])
        ) {
            const formDataDraftMode = currentPanelInitData?.argsAll?.currentPanelInitData?.formData;
            defaultValueOfField = formDataDraftMode?.[fieldId] ?? null;
        }

        return defaultValueOfField;
    };

    return (
        <div className="groupCreate-main" data-cy="qa-ticket-wrap">
            <LoadingPanel isLoading={isLoading} />
            <ButtonSubmitAddTicket
                onClickDraft={handleSubmitSaveDraft}
                onClick={handleSubmitCreateQaTicket(handleCreateQaTicket)}
                onClickDelete={onClickDelete}
                isEnableButtonDelete={argsAll.isDraft}
                selectedFormInfo={selectedFormInfo}
                isDisableButtonDraft={isDisableButtonDraft}
                isDisableButtonSent={isDisableButtonSent}
                {...argsAll}
                ticketType={Constant.TICKET_TYPE.QA}
                isEdited={isEdited}
                setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
            />

            <div className="scrollBar-main">
                <div className="addTicket addTicketQa" data-cy="qa-ticket-add-frame">
                    <ErrorMessageHeader message={errorMessageHeader} />
                    <FormProvider {...validateCreateQaTicket}>
                        <div className={`form-qa ${isCreateInviteTicket() && 'form-qa-invite'}`}>
                            {!isCreateInviteTicket() && <div className="form-qaTicket">
                                <label className="form-qaTicket-label">
                                    {I18n.get('USER04LB029')}
                                </label>
                                <div
                                    className="form-qaTicket-control"
                                    data-cy="qa-ticket-select-contact-desk"
                                >
                                    <FormInput
                                        className="form-control form-control--wrap form-control--hg40"
                                        select
                                        variant="outlined"
                                        name="projectTarget"
                                        value={projectTarget ? projectTarget : ''}
                                        defaultValue={projectTarget ? projectTarget : ''}
                                        required
                                        errorlist={errorCreateQaTicket}
                                        SelectProps={{
                                            value: projectTarget,
                                            open: isOpenSelectProject,
                                            onClose: e => handleCloseSelectProject(argsAll),
                                            onOpen: e => handleOpenSelectProject(argsAll),
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                getContentAnchorEl: null,
                                                className: 'selectDrop'
                                            }
                                        }}
                                        disabled={!isEnableFields()}
                                    >
                                        {Utils.isEmptyArray(internalHelpDeskList) &&
                                            Utils.isEmptyArray(externalHelpDeskList) && (
                                                <MenuItem style={{ display: 'none' }}></MenuItem>
                                            )}

                                        {/* internalHelpDeskList */}
                                        {!Utils.isEmptyArray(internalHelpDeskList) &&
                                            projectInuseDetail.type !==
                                                Constant.PROJECT_TYPE.CUSTOMER && (
                                                <ListSubheader
                                                    className="fontw-bold select-item"
                                                    color="inherit"
                                                    disableSticky
                                                    onClickCapture={e => e.stopPropagation()}
                                                >
                                                    {I18n.get('USER04BTN007')}
                                                </ListSubheader>
                                            )}
                                        {!Utils.isEmptyArray(internalHelpDeskList) &&
                                            internalHelpDeskList?.map(projectInternal => {
                                                if (projectInternal.id !== currentProjectId) {
                                                    return (
                                                        <MenuItem
                                                            key={projectInternal?.id}
                                                            value={projectInternal?.id}
                                                            data-cy="qa-ticket-item-contact-desk"
                                                            onClickCapture={e => {
                                                                handleOnchangeProject(e, argsAll, projectInternal?.id);
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <OverFlowTooltipWithTabsMui
                                                                value={getProjectInternalLabel(
                                                                    projectInternal
                                                                )}
                                                            />
                                                        </MenuItem>
                                                    );
                                                }
                                                return null;
                                            })}

                                        {/* externalHelpDeskList */}
                                        {!Utils.isEmptyArray(externalHelpDeskList) && (
                                            <ListSubheader
                                                className="fontw-bold select-item"
                                                color="inherit"
                                                disableSticky
                                                onClickCapture={e => e.stopPropagation()}
                                            >
                                                {I18n.get('USER04BTN008')}
                                            </ListSubheader>
                                        )}
                                        {!Utils.isEmptyArray(externalHelpDeskList) &&
                                            externalHelpDeskList?.map(projectExternal => {
                                                return (
                                                    <MenuItem
                                                        key={projectExternal?.id}
                                                        value={projectExternal?.id}
                                                        data-cy="qa-ticket-item-contact-desk"
                                                        onClickCapture={e => {
                                                            handleOnchangeProject(e, argsAll, projectExternal?.id);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <OverFlowTooltipWithTabsMui
                                                            value={getProjectLabel(
                                                                projectExternal,
                                                                corporationDetail
                                                            )}
                                                        />
                                                    </MenuItem>
                                                );
                                            })}
                                    </FormInput>
                                </div>
                            </div>}
                            <div className={`form-qaTicket ${isCreateInviteTicket() && 'form-qaTicket-invite'}`}>
                                <label className="form-qaTicket-label">
                                    {I18n.get('USER04LB028')}
                                </label>
                                <div
                                    className="form-qaTicket-control"
                                    data-cy="qa-ticket-select-form"
                                >
                                    <TextField
                                        className="form-control form-control--wrap form-control--hg40"
                                        select
                                        variant="outlined"
                                        name="selectedForm"
                                        value={selectedForm ? selectedForm : ''}
                                        defaultValue={selectedForm ? selectedForm : ''}
                                        required
                                        errorlist={errorCreateQaTicket}
                                        SelectProps={{
                                            value: selectedForm,
                                            open: isOpenSelectForm,
                                            onClose: e => handleCloseSelectForm(argsAll),
                                            onOpen: e => handleOpenSelectForm(argsAll),
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                getContentAnchorEl: null,
                                                className: 'selectDrop'
                                            }
                                        }}
                                        disabled={!isEnableFields()}
                                    >
                                        {Utils.isEmptyArray(formList) && (
                                            <MenuItem style={{ display: 'none' }}></MenuItem>
                                        )}

                                        {!Utils.isEmptyArray(formList) &&
                                            formList?.map(item => {
                                                return (
                                                    <MenuItem
                                                        key={item?.id}
                                                        value={item?.id}
                                                        data-cy="qa-ticket-item-form"
                                                        onClickCapture={e => {
                                                            handleOnchangeForm(e, argsAll, item?.id);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <OverFlowTooltipWithTabsMui
                                                            value={Utils.getTextByLanguage(
                                                                Constant.LANGUAGE_TYPE.JP,
                                                                item.name
                                                            )}
                                                        />
                                                    </MenuItem>
                                                );
                                            })}

                                        {requestType ===
                                            Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST &&
                                            permissionCreateTicketExternalDeskRequest(
                                                userDetail,
                                                projectInuseDetail.type,
                                                formExternalDeskRequestInfo.status,
                                                corporationDetail.contractType
                                            ) && (
                                                <MenuItem
                                                    key={formExternalDeskRequestInfo?.formId}
                                                    value={formExternalDeskRequestInfo?.formId}
                                                    onClickCapture={e => {
                                                        handleOnchangeForm(e, argsAll, formExternalDeskRequestInfo?.formId);
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <OverFlowTooltipWithTabsMui value={I18n.get('USER04BTN010')} />
                                                </MenuItem>
                                            )}

                                        {requestType ===
                                            Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST &&
                                            permissionCreateTicketInviteGuestDesk(
                                                userDetail,
                                                projectInuseDetail.type,
                                                formInviteGuestDeskInfo.status,
                                                corporationDetail.limitValue?.numOfGuestDesk,
                                                corporationDetail.contractType,
                                                corporationDetail.limitValue?.maxNumOfGuestDesk
                                            ) && (
                                                <MenuItem
                                                    key={formInviteGuestDeskInfo?.formId}
                                                    value={formInviteGuestDeskInfo?.formId}
                                                    onClickCapture={e => {
                                                        handleOnchangeForm(e, argsAll, formInviteGuestDeskInfo?.formId);
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <OverFlowTooltipWithTabsMui value={I18n.get('USER04BTN011')} />
                                                </MenuItem>
                                            )}
                                    </TextField>
                                </div>
                            </div>
                        </div>

                        {createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK && (
                            <div className="form-addTicket">
                                <label className="form-addTicket-label">
                                    申請先サービスデスク <span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input external-desk-input">
                                    <Autocomplete
                                        disabled={!isEnableFields()}
                                        freeSolo
                                        open={openExternalDeskList}
                                        onOpen={e => setOpenExternalDeskList(true)}
                                        onClose={() => setOpenExternalDeskList(false)}
                                        forcePopupIcon={true}
                                        popupIcon={
                                            <SearchIcon
                                                onClick={e =>
                                                    searchExternalDeskProject(
                                                        argsAll,
                                                        externalDeskRequestKeyword
                                                    )
                                                }
                                            />
                                        }
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        options={externalDeskProjectList}
                                        renderOption={option => (
                                            <OverFlowTooltipWithTabsMui
                                                value={getOptionSearchLabel(
                                                    option,
                                                    externalDeskRequestKeyword
                                                )}
                                            />
                                        )}
                                        getOptionLabel={option =>
                                            getOptionSearchLabel(option, externalDeskRequestKeyword)
                                        }
                                        disableClearable
                                        getOptionSelected={(option, selectedValue) =>
                                            option.title === selectedValue.title &&
                                            option.value === selectedValue.value
                                        }
                                        value={externalDeskRequestProject}
                                        onChange={(e, newValue) =>
                                            selectExternalDeskProject(argsAll, newValue)
                                        }
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                name="externalDeskRequestProject"
                                                variant="outlined"
                                                className="form-control form-control-wrapInput form-control-hg40"
                                                onChange={e =>
                                                    onChangeExternalDeskInput(e, argsAll)
                                                }
                                                value={externalDeskRequestKeyword}
                                                defaultValue={externalDeskRequestKeyword}
                                                required
                                                error={externalDeskProjectErr.error}
                                                helperText={externalDeskProjectErr.helperText}
                                                onBlur={(e) => handleOnBlurExternalDeskRequest(e, argsAll)}
                                            />
                                        )}
                                        filterOptions={(options, object) => options}
                                        onKeyPress={e =>
                                            onKeyPressSearchExternalDeskProject(
                                                e,
                                                argsAll,
                                                externalDeskRequestKeyword
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        )}

                        {permissionShowFormCreateTicket() &&
                            fieldListData
                                .filter(field => field.type !== 'WORKFLOW')
                                .map((fieldData, i) => (
                                    <RenderFieldUI
                                        hasEditFieldPermissions={isEnableFields()}
                                        API={props?.API}
                                        UI={fieldData.structure.UI}
                                        label={
                                            fieldData.fieldLabel
                                                ? Utils.getTextByLanguage(
                                                      Constant.LANGUAGE_TYPE.JP,
                                                      fieldData.fieldLabel
                                                  )
                                                : ''
                                        }
                                        errorlist={errorCreateQaTicket}
                                        name={fieldData.fieldId}
                                        data={fieldData}
                                        defaultValue={generateDefaultValueByFieldId(fieldData.fieldId)
                                        }
                                        triggerValidate={triggerValidate}
                                        key={fieldData.fieldId}
                                        // Drop file props
                                        fileUploadList={fileUploadList}
                                        setFileUploadList={setFileUploadList}
                                        register={registerCreateQaTicket}
                                        setValue={setValueCreateQaTicket}
                                        getValues={getValuesCreateQaTicket}
                                        clearErrors={clearErrors}
                                        parentForm={selectedFormInfo}
                                        autoFillObject={autoFillObject}
                                        setAutoFillObject={setAutoFillObject}
                                        isEdited={isEdited}
                                        setIsEdited={setIsEdited}
                                        isExChangeTagField={isExChangeTagField}
                                        setIsExChangeTagField={setIsExChangeTagField}
                                        listFieldEdited={listFieldEdited}
                                        setListFieldEdited={setListFieldEdited}
                                        editTicket={
                                            Utils.isEmptyObject(argsAll.draftData) ? false : true
                                        }
                                        isDraft={
                                            Utils.isEmptyObject(argsAll.draftData) ? false : true
                                        }
                                        setFileUpdatedList={setFileUpdatedList}
                                        fileUpdatedList={fileUpdatedList}
                                        // Panel
                                        panelId={props.panelId}
                                        tabId={props.tabId}
                                        panelInitData={panelInitData}
                                        setPanelInitData={setPanelInitData}
                                        setOnChangeEdit={setOnChangeEdit}
                                        onChangeEdit={onChangeEdit}
                                        panelList={panelList}
                                        detailTicket={props.detailTicket}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                        isShowIconCopyFieldId={false}
                                        onClickUrlViewTicket={onClickUrlViewTicket}
                                    />
                                ))}
                        {createTicketType ===
                            Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT &&
                            permissionCreateTicketInviteGuestDesk(
                                userDetail,
                                projectInuseDetail.type,
                                formInviteGuestDeskInfo.status,
                                corporationDetail.limitValue?.numOfGuestDesk,
                                corporationDetail.contractType,
                                corporationDetail.limitValue?.maxNumOfGuestDesk
                            ) && (
                            <FieldInvitedPartnerB2b
                                disabled={!isEnableFields()}
                                setValue={setValueCreateQaTicket}
                                getValues={getValuesCreateQaTicket}
                                clearErrors={clearErrors}
                                errorlist={errorCreateQaTicket}
                                setErrorCreateTicket={setErorsQATicket}
                                defaultMaxGeneralId= {
                                    currentPanelInitData.formData &&
                                    currentPanelInitData.formData['maxGeneralId']
                                        ? currentPanelInitData.formData['maxGeneralId']
                                        : defaultMaxGeneralId
                                }
                                defaultSubdomainInvited= {
                                    currentPanelInitData.formData &&
                                    currentPanelInitData.formData['subDomainInvited']
                                        ? currentPanelInitData.formData['subDomainInvited']
                                        : defaultSubdomainInvited
                                    }
                                ticketType={Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT}
                                setIsEdited={setIsEdited}
                                register={registerCreateQaTicket}
                            />
                        )}
                    </FormProvider>
                </div>
            </div>

            {!isDraftMode && <DialogConfirmChangeDeskOrForm {...argsAll} />}
            {isDraftMode && (
                <DialogConfirmChangeTicketTypeDraftFlow
                    {...argsAll}
                    isHelpDesk={false}
                    isQA={true}
                    isConfirmChangeTicketType={isOpenDialogQAConfirmChangeTicketType}
                    setIsOpenDialogQAConfirmChangeTicketType={
                        setIsOpenDialogQAConfirmChangeTicketType
                    }
                />
            )}
            {isDraftMode && (
                <DialogConfirmChangeForm
                    {...argsAll}
                    isHelpDesk={false}
                    isQA={true}
                    isConfirmChangeForm={isOpenDialogQAConfirmChangeFormType}
                    setIsOpenDialogQAConfirmChangeFormType={setIsOpenDialogQAConfirmChangeFormType}
                />
            )}
            <DialogConfirmCancelCreateTicket
                {...argsAll}
                onClickSaveDraft={handleSubmitSaveDraft}
                handleSubmitSentDraft={handleSubmitCreateQaTicket(handleCreateQaTicket)}
                isDisableButtonSend={isDisableButtonSent}
                setErrorCreateTicket={setErorsQATicket}
                getValuesCreateTicket={getValuesCreateQaTicket}
                fieldListData={fieldListData}
            />
            <DataChangePleaseReloadModal
                {...argsAll}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={confirmDialogObj.open}
                msgConfirm={confirmDialogObj?.msg}
                closeCallBack={onClickCloseConfirmDialog}
                okCallBack={onClickOkConfirmDialog}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
            <DialogConfirmChangeTicketError {...argsAll} isOpen={isOpenPopupError} />
            <DialogConfirmCancelEditTicket
                detailTicket={props?.detailTicket}
                isConfirmCancelEditTicket={isConfirmCancelEditTicket}
                setCloseTabIdState={() => {}}
                setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
                handleResetFormData={handleResetFormData}
                setDisplayMode={setDisplayMode}
            />
        </div>
    );
}

QATicket.propTypes = {
    panelId: PropTypes.string,
    tabId: PropTypes.string,
    setTriggerReLoadHelpdeskTicketDetail: PropTypes.func,
    detailTicket: PropTypes.shape({
        id: PropTypes.string
    })
}